
import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import {useAppSelector} from '@/store/hooks.js';

// Définition de la requête GraphQL pour obtenir tous les modèles de rétribution
const GET_ALL_RETRIBUTION_MODELS = gql`
  query ALL_RETRIBUTION_MODELS($companyUuid: ID!) {
    allRetributionModels(companyUuid: $companyUuid) {
      moreThanTenConsultants
      upToFiveConsultants
      upToTenConsultants
      uuid
    }
  }
`;

const useAllRetributionModels = () => {
  const user = useAppSelector((state) => state.auth.currentUser);
  const companyUuid = user.company.uuid;

  const { loading, error, data, refetch } = useQuery(GET_ALL_RETRIBUTION_MODELS, {
    variables: { companyUuid },
    fetchPolicy: "network-only",
  });

  return {
    loading,
    error,
    retributionModels: data?.allRetributionModels,
    refetch
  };
};

export default useAllRetributionModels;
